module.exports = __webpack_public_path__ + "static/002.thumb-f1fb3581f038271bb40e10e61b3beddd.jpg";